import React from 'react';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from 'prop-types';
import loaderStyle from '../theme/styles/components/Loader';

const useStyles = makeStyles(loaderStyle);

// Show loading for whole application
const AppLoader = ({ height }) => {
  const classes = useStyles();

  return (
    <Container component="main">
      <div style={{ height }} className={classes.loader}>
        <CircularProgress color="inherit" />
      </div>
    </Container>
  );
};

AppLoader.propTypes = {
  height: PropTypes.string,
};
AppLoader.defaultProps = {
  height: '95vh',
};

export default AppLoader;
